import {Directive, ElementRef, Input, Output, OnChanges, EventEmitter, HostListener} from '@angular/core';

@Directive({
  selector: '[appContenteditableModel]'
})
export class ContenteditableModelDirective implements OnChanges {

  private lastViewModel: any;

  @Input('contenteditableModel') contenteditableModel: any;
  @Output('contenteditableModelChange') contenteditableModelChange = new EventEmitter();

  @HostListener('blur') onBlur() {
    const value = this.elRef.nativeElement.innerHTML;
    this.lastViewModel = value;
    this.contenteditableModelChange.emit(value)
  };
  @HostListener('mouseup') onMouseUp() {
    const selected: any = window.getSelection();
    console.log(selected);
  };

  constructor(private elRef: ElementRef) {
  }

  ngOnChanges(changes: any) {
    if (changes.model) {
      this.lastViewModel = this.contenteditableModel;
      this.refreshView()
    }
  }

  private refreshView() {
    this.elRef.nativeElement.innerHTML = this.contenteditableModel
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/directives/contentEditable.directive.ts